import _classCallCheck from "/home/mills/projects/opensourceradio/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/mills/projects/opensourceradio/client/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 * Copyright (C) 2016 Bilibili. All Rights Reserved.
 *
 * @author zheng qian <xqq@xqq.im>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RangeSeekHandler =
/*#__PURE__*/
function () {
  function RangeSeekHandler(zeroStart) {
    _classCallCheck(this, RangeSeekHandler);

    this._zeroStart = zeroStart || false;
  }

  _createClass(RangeSeekHandler, [{
    key: "getConfig",
    value: function getConfig(url, range) {
      var headers = {};

      if (range.from !== 0 || range.to !== -1) {
        var param;

        if (range.to !== -1) {
          param = "bytes=".concat(range.from.toString(), "-").concat(range.to.toString());
        } else {
          param = "bytes=".concat(range.from.toString(), "-");
        }

        headers['Range'] = param;
      } else if (this._zeroStart) {
        headers['Range'] = 'bytes=0-';
      }

      return {
        url: url,
        headers: headers
      };
    }
  }, {
    key: "removeURLParameters",
    value: function removeURLParameters(seekedURL) {
      return seekedURL;
    }
  }]);

  return RangeSeekHandler;
}();

export default RangeSeekHandler;